import styled from 'styled-components';

import appTheme from '../../../themes/Theme';

export const StyledWrapper = styled.span`
  background-color: ${appTheme.highlightTextColor};
  border-radius: 6px;
  padding: 4px 8px;
  margin: 0 4px 0 2px;
  word-wrap: break-word;
`;
